module.exports = __webpack_public_path__ + "img/pin-buzo.680ae78c.png";